import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Modal } from "react-bootstrap";
import { UsePlaceAuth } from '../../../../../AppContext/AppContext';
import { apiData } from '../../../../../actions';
import DataLoader from '../../../../../Utils/DataLoader';
import { Rate } from 'antd';
// import axios from 'axios';
import Autocomplete from "react-google-autocomplete";
// import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom/dist';
import { useDispatch, useSelector } from 'react-redux';
import { Hotel, setPlace } from '../../../../../Redux/Action/Action';
import AdrenalineRush from '../../../thingsToDo/adrenalineRush/AdrenalineRush';
import OwlCarousel from 'react-owl-carousel';

const Hotel_Go_to = () => {
	// let location = useLocation()
	let BtnMore = useRef(null);
	const [loading, setLoading] = useState(true);
	const [comedyDeal, setcomedyDeal] = useState([]);
	const [familyDeal, setFamilyDeal] = useState([]);
	const [escapeDeal, setEscapeDeal] = useState([]);
	const [wineryDeal, setWineryDeal] = useState([]);
	const [beautifulCityAll, setBeautifulCityAll] = useState("");
	const [beautifulCity, setBeautifulCity] = useState("");
	const [seeMoreModal, setSeeMoreModal] = useState(false);
	const [stay_hotel, setStay_Hotel] = useState([]);
	const [viewLink, setViewLink] = useState("");
	const [eatPlace, setEatPlace] = useState([]);
	const [tour, setTour] = useState([]);
	const place = useSelector(state => state.place);
	const [loader, setLoader] = useState(false);
	const [Fine_dining, setFine_dining] = useState("");
	// const { active, setActive } = UsePlaceAuth();
	const dispatch = useDispatch();
	const { BannerPic, setBannerPic } = UsePlaceAuth();
	const [BannerAdv, setBannerAdv] = useState("");
	let navigate = useNavigate();

	const BannerImage = async () => {
		setLoader(true);
		let payload = {
			city: place,
		};
		let apiRes = await apiData.Ban_Image(payload);
		if (apiRes?.status >= 200 && apiRes?.status <= 399) {
			setBannerPic(apiRes?.data?.hits[0]?.largeImageURL);
			setLoader(false);

		}
	};

	var settings1 = {
		items: 4,
		loop: true,
		autoplay: true,
		autoplayTimeout: 3000,
		autoplayHoverPause: true,
		nav: true,
		dots: false,
		responsive: {
			0: {
				items: 1
			},
			768: {
				items: 2
			},
			991: {
				items: 4
			}
		}
	};
	var settings2 = {
		items: 4,
		loop: true,
		autoplay: true,
		autoplayTimeout: 3000,
		autoplayHoverPause: true,
		nav: true,
		dots: false,
		responsive: {
			0: {
				items: 1
			},
			768: {
				items: 2
			},
			991: {
				items: 4
			}
		}
	};

	const options = {
		items: 4,
		loop: true,
		autoplay: true,
		autoplayTimeout: 3000,
		autoplayHoverPause: true,
		nav: true,
		dots: false,
		responsive: {
			0: {
				items: 1
			},
			768: {
				items: 2
			},
			991: {
				items: 4
			}
		}
	};

	var settings3 = {
		items: 4,
		loop: true,
		autoplay: true,
		autoplayTimeout: 3000,
		autoplayHoverPause: true,
		nav: true,
		dots: false,
		responsive: {
			0: {
				items: 1
			},
			768: {
				items: 2
			},
			991: {
				items: 4
			}
		}
	};
	const Comedy = async () => {
		let payload = {
			city: place,
			keyword: "comedy",
			limit: 12
		};

		let apiRes = await apiData.getYelpDeals(payload);
		if (apiRes?.status >= 200 && apiRes?.status <= 399) {
			setcomedyDeal(apiRes?.data?.data?.businesses);
		}
	}
	const Family_Top_Attractions = async () => {
		let payload = {
			city: place,
			keyword: "family attractions",
			limit: 12
		};
		let apiRes = await apiData.getYelpDeals(payload);
		if (apiRes?.status >= 200 && apiRes?.status <= 399) {
			setFamilyDeal(apiRes?.data?.data?.businesses);
		}
	};
	const Escape_Room = async () => {
		setLoader(true);
		let payload = {
			city: place,
			keyword: "escape-20-room",
			limit: 12
		};
		if (place) {
			let apiRes = await apiData.getYelpDeals(payload);
			if (apiRes?.status >= 200 && apiRes?.status <= 399) {
				setEscapeDeal(apiRes?.data?.data?.businesses);
				setLoader(false);
			}
		}
	};
	const winery = async () => {
		let payload = {
			city: place,
			keyword: "Winery",
			limit: 12
		};
		let apiRes = await apiData.getYelpDeals(payload);
		if (apiRes?.status >= 200 && apiRes?.status <= 399) {
			setWineryDeal(apiRes?.data?.data?.businesses);
			setLoader(false);
		}
	};
	const handleSeeAllClick = async () => {
		setSeeMoreModal(true);
		setTimeout(function () {
			document.getElementById("beautifulCityAll").innerHTML = "";
			let script = document?.createElement('script');
			script.src = beautifulCityAll?.split('"')[1];
			document.getElementById("beautifulCityAll")?.appendChild(script);
		}, 500)
	};
	const Beautiful_city_All = async () => {
		// setLoader(true);
		let payload = {
			city: place,
		};
		let apiRes = await apiData.ToursTravel(payload);
		if (apiRes?.status >= 200 && apiRes?.status <= 399) {
			setBeautifulCityAll(apiRes?.data?.data);
		}
	};
	const Beautiful_city = async () => {
		let payload = {
			city: place,
		};
		let apiRes = await apiData.getBeautifulCity(payload);
		if (apiRes?.status >= 200 && apiRes?.status <= 399) {
			setBeautifulCity(apiRes?.data?.data);
		}
	};

	const Specific_Hotel = async () => {
		let payload = {
			city: place,
		};
		let apiRes = await apiData.get_Specific_Hotel(payload);
		if (apiRes?.status >= 200 && apiRes?.status <= 399) {
			setStay_Hotel(apiRes?.data?.data[0].content.split('"')[1]);
		}
	};
	const getTourDeals = async () => {
		let payload = {
			city: place,
			limit: 5
		};
		let apiRes = await apiData.get_Tour(payload);
		if (apiRes?.status >= 200 && apiRes?.status <= 399) {
			setTour(apiRes?.data?.data?.data?.travelExperienceProducts?.resultList);
		}
	};
	const GetHotelView = async () => {
		let payload = {
			city: place,
		};
		let apiRes = await apiData.get_Hotel_View(payload);
		if (apiRes?.status >= 200 && apiRes?.status <= 399) {
			setViewLink(apiRes?.data?.data);
		}
	};
	const GetEat = async () => {
		let payload = {
			city: place,
		};
		let apiRes = await apiData.get_to_eat(payload);
		if (apiRes?.status >= 200 && apiRes?.status <= 399) {
			setEatPlace(apiRes?.data?.data);
		}
	};

	const GetBanners = async () => {
		let payload = {
			city: place,
		};
		let apiRes = await apiData.getBanners(payload);
		if (apiRes?.status >= 200 && apiRes?.status <= 399) {
			setBannerAdv(apiRes?.data);
		}
	};
	const fineDiningArray = Fine_dining ? Object.values(Fine_dining) : [];

	const Get_Fine_Dining = async () => {
		let payload = {
			city: place,
			keyword: "fine dining",
			limit: 12
		};
		let apiRes = await apiData.getYelpDeals(payload);
		if (apiRes?.status >= 200 && apiRes?.status <= 399) {
			setFine_dining(apiRes?.data?.data?.businesses);
			setLoader(false);
		}
	};

	const handleSearch = (e) => {
		if (e.key.toLowerCase() == "enter") {
			e.preventDefault();
			const place = e.target.value.toLowerCase();
			navigate(`/hotels/${place}`);
			dispatch(setPlace(place));
			window.location.reload();
			// executeScript();
		}
	};

	useEffect(() => {
		dispatch(Hotel());
		setLoader(true);
		document.getElementById("tour").innerHTML = "";
		let script = document?.createElement('script');
		script.src = beautifulCity?.split('"')[1];
		document.getElementById("tour")?.appendChild(script);
		Specific_Hotel();
		Comedy();
		Family_Top_Attractions();
		Escape_Room();
		winery();
		getTourDeals();
		GetHotelView();
		GetEat();
		Get_Fine_Dining();
		BannerImage();
		GetBanners();
		Beautiful_city_All()
		Beautiful_city()

		// Added dependencies to the dependency array
	}, [place, stay_hotel, beautifulCity, dispatch]);
	// console.log("stay_hotel",stay_hotel);
	useEffect(() => {
		setTimeout(() => {
			const element = document.querySelector(".beautifulBtn");
			if (element) {
				element.style.display = "block";
			} else {
				console.warn("Element with class 'beautifulBtn' not found.");
			}
		}, 8000);
	}, []);
	const getUserEmail = () => {
		try {
			const rawUser = localStorage.getItem('userEmail');
			const user = JSON.parse(rawUser);
			return user?.email || '';
		} catch (error) {
			// Handle plain string fallback
			// console.error('Failed to parse userEmail from localStorage:', error);
			const rawUser = localStorage.getItem('userEmail');
			if (rawUser && typeof rawUser === 'string' && rawUser.includes('@')) {
				return rawUser;
			}
			return '';
		}
	};

	// Usage
	const userEmail = getUserEmail();

	const handleClicks = () => {
		handleSubmit();
	};
	const [formData, setFormData] = useState({
		email: '',
		city: '',
		travelerType: '',
	});
	const handleSubmit = async () => {
		const email = userEmail;
		if (!email) {
			console.log('Please log in to continue.');
			return;
		}
		const { city, travelerType } = formData;
		const finalCity = place || city;
		// Only call split if email is a string and contains '@'
		let firstName = '';
		if (typeof email === 'string' && email.includes('@')) {
			firstName = email.split('@')[0];
		}
		// Construct the URL dynamically
		const url = `https://backend.mysittivacations.com/api/user-subscription?email=${encodeURIComponent(email)}&firstName=${encodeURIComponent(firstName)}&city=${encodeURIComponent(finalCity)}&travelerType=${encodeURIComponent(travelerType)}`;

		try {
			const response = await fetch(url, {
				method: 'GET',
			});

			if (response.ok) {
				const data = await response.json();
				console.log(data.message);
			} else {
				let error = 'Submission failed';
				try {
					const errData = await response.json();
					error = errData.message || error;
				} catch { }
				console.log(error);
			}
		} catch (error) {
			console.log(error.message || 'Failed to submit form');
		}
	};

	useEffect(() => {
		dispatch(Hotel());

		const existingScript = document.querySelector('script[src*= "https://tp.media/content?trs=26480&shmarker=130544&show_hotels=false&powered_by=false&locale=en&currency=usd&searchUrl=travel.mysittivacations.com/hotels&color_button=%23196AE1&color_icons=%23196AE1&secondary=%23FFFFFF&dark=%23262626&light=%23FFFFFF&special=%23C4C4C4&color_focused=%23196ae1&border_radius=5&plain=true&promo_id=7873&campaign_id=101"]');

		const waitForWidget = () => {
			const checkInterval = setInterval(() => {
				const loadedEl = document.querySelector('.cascoon-tabs-button--active');
				if (loadedEl) {
					setLoading(false);
					clearInterval(checkInterval);
				}
			}, 300);

			setTimeout(() => {
				clearInterval(checkInterval);
				setLoading(false);
			}, 100);
		};

		if (!existingScript) {
			const script = document.createElement('script');
			script.src =
				"https://tp.media/content?trs=26480&shmarker=130544&show_hotels=false&powered_by=false&locale=en&currency=usd&searchUrl=travel.mysittivacations.com/hotels&color_button=%23196AE1&color_icons=%23196AE1&secondary=%23FFFFFF&dark=%23262626&light=%23FFFFFF&special=%23C4C4C4&color_focused=%23196ae1&border_radius=5&plain=true&promo_id=7873&campaign_id=101";
			script.id = "tpHotelScript";

			script.onload = () => {
				waitForWidget();
			};

			script.onerror = () => setLoading(false);

			document.getElementById("hotelSearch")?.appendChild(script);
		} else {
			waitForWidget(); // widget may already be injected
		}

		return () => {
			const existingScript = document.getElementById("tpHotelScript");
			if (existingScript) {
				existingScript.remove();
			}

			const hotelEl = document.getElementById("hotelSearch");
			if (hotelEl) {
				hotelEl.innerHTML = "";
			}
		};
	}, []);

	const localSelectedCity = localStorage.getItem('selectedCity');


	return (
		<Fragment>
			<div className="hotels-banner-section rest-sec">
				<div id="hotelSearch" className="hotel-search-container">
					{loading && (
						<DataLoader />
					)}
				</div>
			</div>

			<div className="adver-sec">
				<div className="container">
					<div className="row">
						<div className="col-12 col-sm-12 col-md-12 col-lg-12">
							{BannerAdv?.data && <div dangerouslySetInnerHTML={{ __html: BannerAdv?.data }} />}
						</div>
					</div>
				</div>
			</div>
			<div className="flight-sec Things-sec audio">
				<div className="container">
					<div className="row">
						<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
							<div className="white-box-area inner rest-deals">
								<div className="row">
									<div className="col-lg-12 col-12">
										<section className="client-sec comedy">
											<div className="col-12 col-md-12 col-lg-12">
												<div className="slider-main">
													<div className="slider-sec">
														<h2>{localSelectedCity && localSelectedCity !== 'undefined'
															? `See Beautiful ${place?.replace(/\b\w/g, x => x?.toUpperCase())}`
															: 'See Beautiful'}</h2>
														<p>Get set for an awesome vacation! Explore sightseeing tours, bus excursions, and exclusive passes. Uncover hidden gems, create memorable moments, and elevate your trip. Time to make the most of it – book your tours now and let the adventure begin!</p>
													</div>
													<div id="tour"></div>
													<div className="view-tag clickable">
														<a id="beautifulBtn" ref={BtnMore} onClick={handleSeeAllClick} className='m-4'>
															See All
														</a>
													</div>
												</div>
											</div>

											<AdrenalineRush />
											<div className="flight-sec exitment-sec tour-slider">
												<div className="slider-sec">
													<h3>{localSelectedCity && localSelectedCity !== 'undefined' ? `${place?.replace(/\b\w/g, x => x?.toUpperCase())} Tours` : "Tours"}</h3>
													<p>Save big on thrilling tours and sightseeing adventures! We've found Groupon deals for helicopter rides, bus tours, and more. Experience the best while keeping your wallet happy.</p>

													<div className="slider-main slider-section discount-section stay-sec comn-div">
														<div className="container">
															<div className="row">
																<div className="col-12 col-md-12 col-lg-12">
																	{tour && tour.length > 0 ? (
																		<OwlCarousel {...settings1}>
																			{tour.map((ele, index) => (
																				<div
																					key={ele?.id || index}
																					data-aos="zoom-in-right"
																					className="slider-block"
																				>
																					<a href={ele?.link} onClick={handleClicks}>
																						<img loading="lazy" src={ele?.imageLink} alt="Tours" />
																						<div className="slider-content">
																							<div className="slider-content-inner">
																								<h3>
																									{ele?.title.length >= 20
																										? `${ele?.title.slice(0, 20)}...`
																										: ele?.title}
																								</h3>
																								<p>{ele?.description.slice(0, 30)}..</p>
																							</div>																
																							<div className="discount-action hotels purple-bg city-price">
																								<div className="review-sec">
																									<p>
																										{ele?.price?.amount !== ele?.salePrice?.amount && (
																											<span className="old-price">${ele?.price?.amount}</span>
																										)}{" "}
																										<span className="new-price">${ele?.salePrice?.amount}</span>{" "}
																										{ele?.price?.amount !== ele?.salePrice?.amount && (
																											<span className="dis-percent">
																												{(() => {
																													const originalPrice = Number(ele?.price?.amount);
																													const salePrice = Number(ele?.salePrice?.amount);
																													const discount =
																														originalPrice && salePrice
																															? Math.max(0, Math.round(((originalPrice - salePrice) / originalPrice) * 100))
																															: 0;
																													return `${discount}%`;
																												})()}
																											</span>
																										)}
																									</p>
																									<a className="siti-btn">Book Now</a>
																								</div>
																							</div>
																						</div>
																					</a>
																				</div>
																			))}
																		</OwlCarousel>
																	) : (
																		`Oops! No Data Available ${`For ${place.replace(/\b\w/g, (x) => x.toUpperCase())}`}`
																	)}

																</div>
															</div>
														</div>
													</div>
												</div>
											</div>

											<div className="flight-sec exitment-sec tour-slider">
												<div className="slider-sec">
													<h3>{localSelectedCity && localSelectedCity !== 'undefined' ? `Escape Room ${place?.replace(/\b\w/g, x => x?.toUpperCase())}` : 'Escape Room'}</h3>
													<p>Unleash your inner detective in our thrilling escape room! Solve puzzles, decode clues, and unlock secrets in a race against time. Can you escape?</p>

													{
														!loader ? <div data-aos="zoom-in-left" className="slider-main">
															<div className="container">
																<div className="row">
																	{escapeDeal && escapeDeal.length > 0 ? (
																		<OwlCarousel {...settings3}>
																			{escapeDeal.map((ele, index) => (
																				<div className="col-12 col-md-12 col-lg-12" key={ele?.id || index}>
																					<div className="slider-block">
																						<a href={ele?.url} onClick={handleClicks}>
																							<img loading="lazy" src={ele?.image_url} alt="escapeDeal" />
																							<div className="slider-content">
																								<h3>{ele?.name.length >= 18 ? `${ele?.name.slice(0, 18)}...` : ele?.name}</h3>
																								<div className="escape-room">
																									<p className="time-formate">
																										<img src="/images/location.svg" alt="locations" />
																										{ele?.location?.city}
																									</p>
																									<Rate
																										allowHalf
																										defaultValue={ele?.rating ? ele?.rating : 4}
																										disabled
																									/>
																									<p
																										style={{ cursor: "pointer" }}
																										data-toggle="modal"
																										data-target="#myModal-review"
																										data-id="X8ZS-dgiMIJvhwf9SaDnjw"
																									>
																										{ele?.review_count}
																									</p>
																								</div>
																								<div className="review-sec">
																									<a className="siti-btn full">
																										{ele?.categories ? ele?.categories[0]?.title : "Escape Games"}
																									</a>
																								</div>
																							</div>
																						</a>
																					</div>
																				</div>
																			))}
																		</OwlCarousel>
																	) : (
																		`Oops! No Data Available ${`For ${place.replace(/\b\w/g, (x) => x.toUpperCase())}`}`
																	)}
																</div>
															</div>
														</div>
															:
															<DataLoader />
													}
												</div>
											</div>
											<div className="flight-sec exitment-sec new1">
												<div className="slider-sec">
													<h3>{localSelectedCity && localSelectedCity !== 'undefined' ? `Family Top Attractions in ${place?.replace(/\b\w/g, x => x?.toUpperCase())}` : 'Family Top Attractions'}</h3>

													<div data-aos="zoom-in-right" className="slider-main">
														<div className="container">
															<div className="row">
																{familyDeal && familyDeal.length > 0 ?
																	<OwlCarousel {...settings1}>
																		{familyDeal.map((ele, index) => {
																			return (
																				<div key={ele?.id || index} data-aos="zoom-in-right" className="slider-block">
																					<div className="slider-block">
																						<img loading="lazy" src={ele?.image_url} alt="Family" />
																						<div className="slider-content">
																							<h3>
																								{ele?.name.length >= 18
																									? `${ele?.name.slice(0, 18)}...`
																									: ele?.name}
																							</h3>
																						</div>
																						<div className="escape-room">
																							<p className="time-formate">
																								<img src="/images/location.svg" alt="location" />
																								{ele?.location?.city}
																							</p>
																							<div className="review-sec">
																								<span className="fa fa-star checked"></span>
																								<span className="fa fa-star checked"></span>
																								<span className="fa fa-star checked"></span>
																								<span className="fa fa-star checked"></span>
																								<span className="fa fa-star checked"></span>
																								<span
																									className="reviews yelpuser-review"
																									style={{ cursor: "pointer" }}
																									data-toggle="modal"
																									data-target="#myModal-review"
																									data-id="X8ZS-dgiMIJvhwf9SaDnjw"
																								>
																									({ele?.review_count})
																								</span>
																							</div>
																						</div>
																						<a href={ele?.url} onClick={handleClicks}>{ele?.categories[0]?.title}</a>
																					</div>
																				</div>
																			);
																		})}
																	</OwlCarousel> : `Oops! No Data Available ${`For ${place.replace(/\b\w/g, (x) => x.toUpperCase())}`}`}
															</div>
														</div>
													</div>
												</div>
											</div>
											<div className="adver-sec">
												<div className="container">
													<div className="row">
														<div className="col-12 col-sm-12 col-md-12 col-lg-12">
															<a href="https://www.dpbolvw.net/click-8265264-13167950" target="_top">
																<img loading="lazy" src="https://www.lduhtrp.net/image-8265264-13167950" width="728" height="90" alt="" border="0" /></a>
														</div>
													</div>
												</div>
											</div>

											<div className="flight-sec exitment-sec tour-slider new2">
												<div className="slider-sec">
													<h3>Winery</h3>
													<div className="container">
														<div className="row">
															{wineryDeal && wineryDeal.length > 0 ? (
																<OwlCarousel {...options}>
																	{wineryDeal.map((ele, index) => (
																		<div data-aos="zoom-in-right" className="slider-main winneyMain" key={ele?.id || index}>
																			<div>
																				<div className="slider-block">
																					<a href={ele?.url} onClick={handleClicks} target="_self">
																						<img loading="lazy" src={ele?.image_url} alt="Winery" />
																						<div className="slider-content winery-content">
																							<h3>
																								{ele?.name.length >= 18 ? `${ele?.name.slice(0, 18)}...` : ele?.name}
																							</h3>
																							<div className="escape-room">
																								<p>
																									<i className="fa fa-calendar" aria-hidden="true"></i> Sat, 12/31/2022
																								</p>
																								<p>
																									<i className="fa fa-clock-o" aria-hidden="true"></i> 07:30 PM
																								</p>
																								<p>
																									<img src="/images/location.svg" alt="location" />
																									{ele?.location?.display_address[0]},
																								</p>
																							</div>
																							<div className="review-sec">
																								<a className="siti-btn full">See More</a>
																							</div>
																						</div>
																					</a>
																				</div>
																			</div>
																		</div>
																	))}
																</OwlCarousel>
															) : (
																`Oops! No Data Available ${`For ${place.replace(/\b\w/g, (x) => x.toUpperCase())}`}`
															)}
														</div>

													</div>
												</div>
											</div>

											<div className="flight-sec exitment-sec tour-slider new3">
												<div className="slider-sec">
													<h2>Comedy</h2>
													{comedyDeal && comedyDeal.length > 0 ? <OwlCarousel  {...settings2}>
														{comedyDeal && comedyDeal?.map((ele, index) => {
															return (
																<div data-aos="zoom-in-left" className="slider-main comedyMain">
																	<div key={ele?.id || index} className="slider-block">
																		<a href={ele?.url} onClick={handleClicks}>
																			<img loading="lazy" src={ele?.image_url} alt='Comedy' />
																			<div className="slider-content">
																				<h3>{ele?.name.slice(0, 18)}</h3>
																				<div className="stars">
																					<ul>
																						<li>
																							<Rate
																								allowHalf
																								defaultValue={ele?.rating}
																								disabled
																							/>
																						</li>
																					</ul>
																					<p>({ele?.review_count} reviews)</p>
																				</div>
																				{/* <p>Breweries</p> */}
																			</div>
																			<div className="escape-room">
																				<p className='time-formate'>
																					<img src="/images/location.svg" alt='location' />
																					{ele?.location?.display_address[0]}
																				</p>
																				<p><i className="fa fa-phone" aria-hidden="true"></i> {ele?.phone}</p>
																			</div>
																		</a>
																	</div>
																</div>
															)
														})}
													</OwlCarousel> : `Oops! No Data Available ${`For ${place.replace(/\b\w/g, (x) => x.toUpperCase())}`}`}

												</div>
											</div>
											<div className="adver-sec">
												<div className="container">
													<div className="row">
														<div className="col-12 col-sm-12 col-md-12 col-lg-12">
															<a href="https://www.tkqlhce.com/click-8265264-14442529" target="_top">
																<img loading="lazy" src="https://www.tqlkg.com/image-8265264-14442529" width="728" height="90" alt="Offer" border="0" /></a>
														</div>
													</div>
												</div>
											</div>
											<div className="flight-sec exitment-sec tour-slider new4">
												<div className="slider-sec">
													<h2>Fine Dining</h2>
													{fineDiningArray && fineDiningArray.length > 0 ? (
														<OwlCarousel {...settings1}>
															{fineDiningArray.map((ele) => (
																<div data-aos="zoom-in-right" className="slider-main" key={ele?.id}>
																	<div className="slider-block">
																		<a href={ele?.url} onClick={handleClicks}>
																			<img loading="lazy" src={ele?.image_url} alt="Fine-Dining" />
																			<div className="slider-content">
																				<h3>{ele?.name.slice(0, 15)}</h3>
																				<div className="escape-room ps-3 pe-1 gap-2 align-items-center">
																					<ul>
																						<li>
																							<Rate allowHalf defaultValue={ele?.rating} disabled />
																						</li>
																					</ul>
																					<p>({ele?.review_count} Reviews)</p>
																				</div>
																			</div>
																		</a>
																	</div>
																</div>
															))}
														</OwlCarousel>
													) : (
														`Oops! No Data Available ${`For ${place.replace(/\b\w/g, (x) => x.toUpperCase())}`}`
													)}

												</div>
											</div>

										</section>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			{/* modal section starts here */}
			<>
				<Modal
					show={seeMoreModal}
					onHide={() => setSeeMoreModal(false)}
					// backdrop="static"
					size="xl"
					className='modal_xl see-pop'
					keyboard={false}
				>
					<Modal.Header closeButton>
					</Modal.Header>
					<Modal.Body id="beautifulCityAll">
					</Modal.Body>
				</Modal>
			</>
		</Fragment>
	)
}
export default Hotel_Go_to